/**
 * Sports Realm — reels carousel arrows.
 *
 * The track scrolls natively (touch, trackpad, keyboard). This only adds the
 * mockup's desktop arrows: step by two cards, hide at each bound, and allow
 * mouse drag. Arrows are hidden below 760px, where native swipe takes over.
 */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.srReelsReady === 'true') return;
    var track = root.querySelector('[data-sr-reels-track]');
    if (!track) return;
    var prev = root.querySelector('[data-sr-reels-prev]');
    var next = root.querySelector('[data-sr-reels-next]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var behavior = reduce ? 'auto' : 'smooth';

    function step() {
      var card = track.querySelector('.sr-reel');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 14;
      return card ? Math.round((card.getBoundingClientRect().width + gap) * 2) : 480;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth - 4;
      if (prev) prev.classList.toggle('sr-is-on', track.scrollLeft > 6);
      if (next) next.classList.toggle('sr-is-off', track.scrollLeft >= max);
    }

    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: behavior }); });
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: behavior }); });
    track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();

    /* Mouse drag (touch already scrolls natively) */
    var down = false, startX = 0, startScroll = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; moved = false; startX = e.clientX; startScroll = track.scrollLeft;
      track.classList.add('sr-is-grabbing');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 5) moved = true;
      track.scrollLeft = startScroll - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      track.classList.remove('sr-is-grabbing');
    });
    // a drag must not trigger the card's link
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    root.dataset.srReelsReady = 'true';
  }

  function initAll(scope) { (scope || document).querySelectorAll('[data-sr-reels]').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else { initAll(document); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
